import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MmuUserService } from '../user-service/mmu-user.service';

@Directive({
  selector: '[mmuUserRole]'
})
export class MmuUserRoleDirective {

  private _show = false;
  private _isRendered = false;

  constructor(
    private userService: MmuUserService,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef) { }

  @Input()
  set mmuUserRole(roles: string[] | string | boolean) {
    if (this.checkPermission(roles)) {
      this.show();
    } else {
      this.hide();
    }
  }

  private checkPermission(roles: string[] | string | boolean): boolean {
    if (Array.isArray(roles)) {
      // Only render if user has one of the roles defined
      for (const role of this.userService.user.roles) {
        if (roles.indexOf(role) >= 0) {
          this._show = true;
          break;
        }
      }
    } else if ((typeof roles === 'string') && (this.userService.user.roles.indexOf(roles) >= 0)) {
      // Show only if user has the single role defined
      this._show = true;
    } else if (typeof roles === 'boolean') {
      // If a boolean input was used, act like a ngIf directive
      this._show = roles;
    }

    return this._show;
  }

  private show() {
    if (!this._isRendered) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this._isRendered = true;
    }
  }

  private hide() {
    this.viewContainerRef.clear();
    this._isRendered = false;
  }
}
